const TrackingModule = (() => {

  // ------------------------------------------------------------------
  // CONSTANTS
  // ------------------------------------------------------------------

  const KEYS = {
    FIRST_CLICK:      'qs_first_click',
    FIRST_VISIT:      'qs_first_visit',
    URL_EVENT_SOURCE: 'qs_url_event_source',
  };

  const AD_PARAMS = [
    'gclid', 'gbraid', 'wbraid',
    'fbclid', 'msclkid', 'ttclid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'ref', 'source',
  ];

  // ------------------------------------------------------------------
  // HELPERS
  // ------------------------------------------------------------------

  function parseParams(urlString) {
    try {
      const url = new URL(urlString);
      const params = {};
      url.searchParams.forEach((value, key) => { params[key] = value; });
      return Object.keys(params).length > 0 ? params : null;
    } catch { return null; }
  }

  function hasAdSignal(params) {
    if (!params) return false;
    return AD_PARAMS.some(key => key in params && params[key] !== '');
  }

  function ssGet(key) {
    try { return sessionStorage.getItem(key); } catch { return null; }
  }

  function ssSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
      localStorage.setItem(key, value);    // mirror to localStorage as well
    } catch { /* silent */ }
  }

  // ------------------------------------------------------------------
  // CAPTURE ON PAGE LOAD
  // ------------------------------------------------------------------

  function captureEntrySignals() {
    const params = parseParams(window.location.href);

    // ① url_event_source — always save raw params if present
    if (params && !ssGet(KEYS.URL_EVENT_SOURCE)) {
      ssSet(KEYS.URL_EVENT_SOURCE, JSON.stringify(params));
    }

    // ② first_visit — set immediately on page load when ad params present
    if (hasAdSignal(params)) {
      if (!ssGet(KEYS.FIRST_VISIT)) {
        ssSet(KEYS.FIRST_VISIT, String(Date.now()));
      }

      // ③ first_click — copied from enhanced script:
      //    set on the FIRST actual user click (not page load),
      //    but only once, and only when first_visit is already set
      if (!ssGet(KEYS.FIRST_CLICK)) {
        const recordFirstClick = () => {
          ssSet(KEYS.FIRST_CLICK, String(Date.now()));
          window.removeEventListener('click', recordFirstClick);
        };
        window.addEventListener('click', recordFirstClick, { once: true });
      }
    }
  }

  // ------------------------------------------------------------------
  // BUILD PAYLOAD
  // ------------------------------------------------------------------

  function getPayload() {
    const rawClick  = ssGet(KEYS.FIRST_CLICK)  || localStorage.getItem(KEYS.FIRST_CLICK);
    const rawVisit  = ssGet(KEYS.FIRST_VISIT)  || localStorage.getItem(KEYS.FIRST_VISIT);
    const rawSource = ssGet(KEYS.URL_EVENT_SOURCE) || localStorage.getItem(KEYS.URL_EVENT_SOURCE);

    const firstClick  = rawClick  ? new Date(Number(rawClick)).toISOString()  : null;
    const firstVisit  = rawVisit  ? new Date(Number(rawVisit)).toISOString()  : null;
    const urlSource   = rawSource || null;
    const leadPageUrl = window.location.href;

    // tracking_metadata — use rich data from enhanced script if loaded,
    // otherwise fall back to simple bundle (copied from enhanced script pattern)
    let trackingMetadata;
    if (typeof window.getLeadTrackingData === 'function') {
      try {
        // Enhanced script is loaded — use its full live bundle
        trackingMetadata = JSON.stringify(window.getLeadTrackingData());
      } catch {
        trackingMetadata = buildSimpleMetadata(firstClick, firstVisit, urlSource, leadPageUrl);
      }
    } else {
      trackingMetadata = buildSimpleMetadata(firstClick, firstVisit, urlSource, leadPageUrl);
    }

    return {
      first_click:       firstClick,
      first_visit:       firstVisit,
      url_event_source:  urlSource,
      lead_page_url:     leadPageUrl,
      tracking_metadata: trackingMetadata,
    };
  }

  function buildSimpleMetadata(firstClick, firstVisit, urlSource, leadPageUrl) {
    return JSON.stringify({
      first_click:      firstClick,
      first_visit:      firstVisit,
      url_event_source: urlSource ? JSON.parse(urlSource) : null,
      lead_page_url:    leadPageUrl,
    });
  }

  // ------------------------------------------------------------------
  // INIT
  // ------------------------------------------------------------------

  function init() {
    captureEntrySignals();
  }

  return { init, getPayload };

})();